/**
 * Returns true only for a parseable http/https URL. Used to guard every
 * dynamic anchor href / window.open target built from AT Protocol record
 * or third-party API data before it reaches a sink. Accepts nullable
 * input directly so callers never need a separate presence check.
 */
export function isSafeUrl(url: string | null | undefined): boolean {
    if (!url) return false
    try {
        const parsed = new URL(url)
        if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return false
        if (parsed.username || parsed.password) return false
        return true
    } catch {
        return false
    }
}
